<app-temp-modal-cadastro #modalConsultar [textHeader]="tituloModal" (closed)="onClose()" [customClass]="'modal-xxl'"
  modalContentId="modal-importacao-detalhar-adicao">
  <form [formGroup]="formAdicao">
    <div class="row">
      <div class="col">
        <table class="table table-hover table-bordered">
          <thead>
            <tr>
              <th>Cód. Produto</th>
              <th>Unidade</th>
              <th>Alíquota ICMS</th>
              <th>% Red. BC ICMS</th>
              <th>CST ICMS</th>
              <th>Código Benefício Fiscal</th>
              <th>Cód. Benef. Cred. Presumido</th>
              <th>% Cred. Presumido</th>
            </tr>
          </thead>
          <tbody formArrayName="mercadorias">
            <tr *ngFor="let mercadoria of $any(formAdicao.get('mercadorias')).controls" [formGroup]="mercadoria">
              <td style="max-width: 180px; overflow: hidden" [ngbTooltip]="mercadoria.get('descricaoMercadoria').value"
                container="body">
                {{mercadoria.get('referenciaItem').value}}
              </td>
              <td>{{mercadoria.get('unidadeMedida').value}}</td>
              <td>
                <input type="text" class="form-control" formControlName="aliquotaICMSSaida"
                  style="max-width: 100px; display: inline-block; width: auto" currencyMask inputmode="numeric"
                  [options]="currencyOptions">
              </td>
              <td>
                <input type="text" class="form-control" formControlName="reducaoBCICMSSaida" style="max-width: 100px"
                  currencyMask inputmode="numeric" [options]="currencyOptions">
              </td>
              <td>
                {{calcularCst(mercadoria)}}
              </td>
              <td style="max-width: 100px">
                <app-combobox-cbenef-fiscais id="form_codigoBeneficioFiscal" label="" formControlName="cBenefSaida" appendTo="#modal-importacao-detalhar-adicao"
                  [customData]="{ cst: calcularCst(mercadoria) }">
                </app-combobox-cbenef-fiscais>
              </td>
              <td style="max-width: 100px">
                <ng-select id="form_cCredPresumido" [loading]="loading['codigosCreditoPresumido']"
                  formControlName="cCredPresumidoSaida" placeholder="Selecione" [items]="codigosCreditoPresumido"
                  bindLabel="descricao" bindValue="codigo" appendTo="#modal-importacao-detalhar-adicao">
                </ng-select>
              </td>
              <td>
                <input class="form-control" type="text" formControlName="pCredPresumidoSaida" currencyMask
                  inputmode="numeric" [options]="currencyOptions" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>

  <div class="m-t-20">
    <button class="btn btn-primary" (click)="salvar()">
      <i class="ti ti-save"></i> Salvar
    </button>
    <button class="btn btn-info" (click)="voltar()">
      Voltar
    </button>
  </div>
</app-temp-modal-cadastro>